import React, { useState } from "react";

import { formatNumber, getCurrentBauYears, useCurrentYearlyDataYear } from "utils";

import { AdminDescriptions, AdminSection, Col, Row } from "components";

import { FieldModuleBauDataUpdate } from "pages/admin/farms/components/FieldModuleBauDataUpdate";

export const FarmFieldModuleBau = ({ module, farmId }) => {
  const [showDrawer, setShowDrawer] = useState(false);
  const { year } = useCurrentYearlyDataYear(farmId);

  const { fieldModuleId, bau } = module;

  // if the module doesnt have 3 years its because its in the current year and we can use getCurrentBauYears
  // and we always want to send it the 3 years so we can add data for uncompleeted years
  const years = module?.bauStatus?.years.length === 3 ? [...module.bauStatus.years] : getCurrentBauYears(year);

  const handleCloseDrawer = () => {
    setShowDrawer(false);
  };

  return (
    <>
      <AdminSection headline="Baseline data" />
      <Row>
        <Col>
          <AdminDescriptions
            items={[
              {
                span: 1,
                label: "Confirmed",
                children: module.bauStatus.confirmed ? "yes" : "no",
              },
              {
                span: 1,
                label: "Years",
                children: module.bauStatus.years ? module.bauStatus.years.map((year) => <span key={year}>{year}, </span>) : "-",
              },
              {
                span: 1,
                label: "Baseline Co2",
                children: formatNumber({
                  number: parseFloat(module.bauCo2),
                  decimalPlaces: 4,
                }),
              },
            ]}
            // Deactivated editing bau for now, only possible via verifications to not add more confusion due to calculation verions
            // extra={
            //   (role === "tier1" || role === "tier2" || role === "tier3") && (
            //     <Button type="secondary" size="small" onClick={() => setShowDrawer(true)}>
            //       Edit BAU data
            //     </Button>
            //   )
            // }
          />
        </Col>
      </Row>

      {bau.map((year, i) => (
        <Row key={i}>
          <Col>
            <AdminDescriptions
              items={Object.entries(year).map(([key, value]) => ({
                span: 1,
                label: key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase()),
                children:
                  typeof value === "number"
                    ? key !== "year"
                      ? formatNumber({
                          number: parseFloat(value),
                          decimalPlaces: 4,
                        })
                      : value
                    : typeof value === "boolean"
                    ? value.toString()
                    : value,
              }))}
            />
          </Col>
        </Row>
      ))}

      {fieldModuleId && showDrawer && (
        <FieldModuleBauDataUpdate years={years} fieldModuleId={fieldModuleId} visible={showDrawer} onClose={() => handleCloseDrawer()} />
      )}
    </>
  );
};
